@for (toast of toastService.toasts; track toast) {
	<ngb-toast [class]="toast.classname" [autohide]="true" [delay]="toast.delay || 5000">
		@if (isTemplate(toast)) {
			<ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
		} @else {
			{{ toast.textOrTpl }}
		}
		<ng-template #text>{{ toast.textOrTpl }}</ng-template>
		<i role="button" class="fa-solid fa-xmark me-2 fs-5 text-white" (click)="toastService.remove(toast)"></i>
	</ngb-toast>
}
